import countryList from 'country-list';
import { parse } from 'query-string';
import { SupportedLanguage } from '../Utils/graphql-sdk';
import { getLang } from '../Utils/locale';
import useBookingMinimalShop from '../Pages/Booking/server-data/use-booking-minimal-shop';
import useGiftcardMinimalShop from '../Pages/Giftcard/server-data/use-giftcard-minimal-shop';
import useBookingEditShop from '../Pages/BookingEdit/server-data/use-booking-edit-shop';
import useMembershipShop from '../Pages/Membership/server-data/use-membership-shop';
import usePageType from './use-page-type';

countryList.overwrite([
  {
    code: 'US',
    name: 'United States',
  },
]);

const supportedLanguages = Object.values(SupportedLanguage).map((value) => {
  return String(value).toLowerCase();
});

export function isSupportedLanguage(string: string): string is SupportedLanguage {
  return supportedLanguages.includes(string.toLowerCase());
}

type SupportedLanguageUnionType = `${SupportedLanguage}`;

export function isSupportedLanguageUnionType(
  string: string
): string is SupportedLanguageUnionType {
  return supportedLanguages.includes(string.toLowerCase());
}

const defaultLang = getLang(parse(window.location.search).lang);

const useLocale = () => {
  const pageType = usePageType();

  // Get country from minimalShop on booking- and giftcard page
  // Get country from shop on other pages
  let country: string | undefined;

  const { data: bookingMinimalShop } = useBookingMinimalShop(false);
  const { data: giftcardMinimalShop } = useGiftcardMinimalShop(false);
  const { data: bookingEditShop } = useBookingEditShop(false);
  const { data: membershipShop } = useMembershipShop(false);

  switch (pageType) {
    case 'booking':
      country = bookingMinimalShop?.country;
      break;
    case 'giftcard':
      country = giftcardMinimalShop?.country;
      break;
    case 'edit-booking':
      country = bookingEditShop?.country;
      break;
    case 'membership':
      country = membershipShop?.country;
      break;
  }

  const languageAsEnum = isSupportedLanguage(defaultLang)
    ? defaultLang
    : SupportedLanguage.En;

  const language = isSupportedLanguageUnionType(defaultLang) ? defaultLang : 'en';

  const countryCode = countryList.getCode(String(country));
  const locale = countryCode ? `${language}-${countryCode}` : language;

  return { locale, countryCode, language, languageAsEnum };
};

export default useLocale;
